import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function SpaRedirector() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirect = params.get("redirect");
    
    if (!redirect) return;

    try {
      const decoded = decodeURIComponent(redirect);
      console.log('[SpaRedirector] Redirecting to:', decoded, 'with hash:', location.hash);
      navigate(`${decoded}${location.hash ?? ""}`, { replace: true });
    } catch (error) {
      console.error('[SpaRedirector] Failed to decode redirect path:', error);
    }
  }, [location.search, location.hash, navigate]);

  return null;
}
